import { render } from "./Key.vue?vue&type=template&id=13a64152&scoped=true"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"

import "./Key.vue?vue&type=style&index=0&id=13a64152&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-13a64152"

export default script